<template>
  <div class="w-100">
    <div class="text-white base-footer align-self-end position-relative">
      <div class="container">
        <div class="row">
          <div
            class="col-12 col-md-3 offset-lg-1 offset-xl-0 col-lg-3 col-xl-3"
            :class="{'d-flex flex-column align-items-center text-center': isMobile}">
            <img
              src="@/assets/icons/logo-footer-resgistro-civil.svg"
              alt="logo oficial do Registro Civil"
              class="base-footer__logo mb-5">
            <h6 class="base-footer__title">
              Institucional
            </h6>
            <div class="base-footer__links-wrapper">
              <a
                href="https://onrcpn.org.br/index.php/politica-de-privacidade/"
                target="_blank">
                Política de privacidade
              </a>
              <a
                href="https://onrcpn.org.br/index.php/privacidade-e-lgpd/"
                target="_blank">
                Privacidade e LGPD
              </a>
              <a
                href="https://status.registrocivil.org.br/status/onrcpn"
                target="_blank">
                Status de serviços
              </a>
              <router-link :to="{ name: 'onrcpn-integracoes' }">
                Integrações ON-RCPN
              </router-link>
            </div>
          </div>
          <div
            class="col-12 col-md-3 col-lg-3 col-xl-3 mt-5"
            :class="{'d-flex flex-column align-items-center text-center': isMobile}">
            <h6 class="base-footer__title">
              Endereço
            </h6>
            <div class="base-footer__info">
              <p class="base-footer__info-address">
                SRTVS Quadra 701
              </p>
              <p class="base-footer__info-address">
                Lote 5, Bloco A – Sala 221 –
              </p>
              <p class="base-footer__info-address">
                Centro Empresarial Brasília
              </p>
              <p class="base-footer__info-address">
                CEP: 70.340-907 – Brasília-DF
              </p>
            </div>
          </div>
          <div
            class="col-12 col-md-3 col-lg-2 col-xl-2 mt-5"
            :class="{'d-flex flex-column align-items-center text-center': isMobile}">
            <h6 class="base-footer__title">
              Sofia REI
            </h6>
            <div class="base-footer__links-wrapper">
              <router-link :to="{ name: 'gerenciador' }">
                Gerenciador de Tarefas
              </router-link>
              <a href="#"
                 @click="acessoAoEsinoreg">
                Sinoreg
              </a>
              <router-link :to="{ name: 'Atendimento' }">
                Fale conosco
              </router-link>
            </div>
          </div>
          <div
            class="base-footer__support-wrapper col-12 col-md-3 col-lg-3 col-xl-4 mt-5"
            :class="{'d-flex flex-column align-items-center text-center': isMobile}">
            <h6 class="base-footer__title">
              Suporte
            </h6>
            <div class="base-footer__info">
              <p class="base-footer__info-contact">
                Fone: (11) 4780-6361
              </p>
              <a class="base-footer__info-contact"
                 href="mailto:atendimento.sofia@registrocivil.org.br">E-mail: atendimento.sofia@registrocivil.org.br</a>
            </div>
            <div class="base-footer__social-media-wrapper">
              <h6 class="base-footer__title mt-5">
                Redes sociais
              </h6>
              <div class="base-footer__social-media-links">
                <a
                  href="https://pt-br.facebook.com/registrocivilorg/"
                  class="icon-facebook-footer"
                  target="_blank" />
                <a
                  href="https://www.instagram.com/registrocivilorg/"
                  class="icon-instagram-footer"
                  target="_blank" />
                <a
                  href="https://twitter.com/reg_civil"
                  class="icon-twitter-footer"
                  target="_blank" />
                <a
                  href="https://www.linkedin.com/company/operador-nacional-registro-civil-do-brasil"
                  class="icon-linkedin-footer"
                  target="_blank" />
                <a
                  href="https://www.youtube.com/channel/UCuGgivUbqDmIpxDRSjhu8NA"
                  class="icon-youtube-footer"
                  target="_blank" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="base-footer-complement align-self-end position-relative">
      <div class="base-footer-complement__wrapper">
        <div class="base-footer-complement__logo-box">
          <div class="base-footer-complement__logo">
            <h6 class="base-footer-complement__title">
              Desenvolvido por
            </h6>
            <img src="@/assets/icons/onrcpn-logo.svg"
                 class=""
                 alt="">
          </div>
          <div class="base-footer-complement__logo">
            <h6 class="base-footer-complement__title">
              Membro
            </h6>
            <img src="@/assets/icons/serp-logo.svg"
                 alt="">
          </div>
        </div>
        <div class="base-footer-complement__info-wrapper">
          <p class="base-footer-complement__info mt-3">
            ® {{ currentYear }} - Todos os direitos reservados - Para uma melhor experiência utilize o Google Chrome
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* outros */
  import moment from 'moment'
  import { mapGetters } from "vuex"

  /* service */
  import MigracaoService from '@/services/MigracaoService'

  export default {
    name: "AppFooter",
    data () {
      return {
        isMobile: false,
        currentYear: moment().format('YYYY')
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId',
        userToken: 'auth/getUserToken'
      })
    },
    beforeMount () {
      this.isMobile = window.deviceMobile
    },
    methods: {
      async acessoAoEsinoreg () {
        const recovery = await MigracaoService.getMigracaoByCartorio(this.cartorioId)
        
        // Só liberamos o acesso ao esinoreg(barramento) para os cartórios que estiverem com o recovery completo
        if (recovery && recovery.status === 'COMPLETED') {
          const path = `${process.env.VUE_APP_ESINOREG_CLIENT_URL}/login?token=${this.userToken}`

          if (path.search('http') >= 0) {
            return window.open(path)
          }

          if (this.$route.name !== 'rei_dashboard') {
            this.$router.push(path)
          }
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
@import "./src/scss/_utilities/variables";

    .base-footer{
        height: 390px !important;
        background: #0D3033;
        padding: 50px 0px 50px 0px;


        @media #{$xs, $sm}{
            height: auto !important;
            padding: 50px 10px 80px 0px;
        }

        &__logo{
            width: 164px;
            height: 57px;

            @media #{$md}{
                width: 150px;
                height: 50px;
            }
        }

        &__title{
            color: #FFFFFF;
            font-size: 16px;
            margin-bottom: 20px;

            @media #{$md}{
                font-size: 14px;
            }

            @media #{$xs, $sm}{
                margin-bottom: 16px;
            }
        }

        &__links-wrapper{
            display: flex;
            flex-direction: column;

             & a{
                color: #FFFFFF;
                font-size: 14px;
                margin-bottom: 3px;

                @media #{$xs, $sm}{
                    margin-bottom: 8px !important;
                }

                @media #{$md}{
                    font-size: 12px;
                }
             }
        }

        &__info{
            & p, a{
                margin-bottom: 5px !important;
                font-size: 14px;
                color: #FFFFFF;


                @media #{$md}{
                    font-size: 12px;
                }

                @media #{$xs, $sm}{
                    margin-bottom: 8px !important;
                }
            }
        }

        &__support-wrapper {
            & .base-footer__title {
                @media #{$xs, $sm}{
                    margin-bottom: 8px !important;
                }
            }
        }

        &__social-media-links{
            display: flex;

            & :is( .icon-facebook-footer,
            .icon-instagram-footer,
            .icon-twitter-footer,
            .icon-linkedin-footer, .icon-youtube-footer){
                width: 34px;
                height: 34px;
                background-repeat: no-repeat;
                margin-right: 7px;
                

                @media #{$lg, $md}{
                    background-size: contain;
                }

                @media #{$xs}{
                    margin-right: 15px;
                }

            }

            & .icon-facebook-footer{
                background-image: url('../assets/icons/facebook-footer.svg');
            }
            & .icon-instagram-footer{
                background-image: url('../assets/icons/instagram-footer.svg');
            }
            & .icon-twitter-footer{
                background-image: url('../assets/icons/twitter-footer.svg');
            }
            & .icon-youtube-footer{
                background-image: url('../assets/icons/youtube-footer.svg');
            }
            & .icon-linkedin-footer{
                background-image: url('../assets/icons/linkedin-footer.svg');
            }

        }

    }

    .base-footer-complement{
        background-color: #092123;
        height: 160px;

        @media #{$xs, $sm}{
            height: auto !important;
            padding-bottom: 50px;
        }


        &__wrapper{
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
        }


        &__logo-box{
            display: flex;
            color: white;
            gap: 55px;
            padding-top: 35px;

            @media #{$xs}{
                flex-direction: column;
            }
        }

        &__title{
            font-size: 13px;
            color: #FFFFFF;
            font-weight: 400;
            text-align: center;
        }

        &__logo{
            & img{
                width: 126px;
            }
        }

        &__info{
            font-size: 12px;
            font-weight: normal;
            color: #FFFFFF;

            @media #{$xs}{
                max-width: 260px;
            }
        }
    }
</style>
